'use client';
import { composeEventHandlers } from '@radix-ui/primitive';
import { DismissableLayer as DismissableLayer$1 } from '@radix-ui/react-dismissable-layer';
import { forwardRef, useCallback } from 'react';
import { jsx } from 'react/jsx-runtime';

var DismissableLayer = forwardRef(
  ({ onInteractOutside, onFocusOutside, onPointerDownOutside, ...props }, ref) => {
    const handleSkipDismissableLayer = useCallback(
      (e) => {
        for (const element of Array.from(
          document.querySelectorAll('[wds-ignore-dismissable-layer="true"]')
        )) {
          const target = e.target;
          if (element.contains(target)) {
            e.preventDefault();
            break;
          }
        }
      },
      []
    );
    return /* @__PURE__ */ jsx(
      DismissableLayer$1,
      {
        ref,
        onPointerDownOutside: composeEventHandlers((e) => {
          handleSkipDismissableLayer(e);
        }, onPointerDownOutside),
        onFocusOutside: composeEventHandlers((e) => {
          handleSkipDismissableLayer(e);
        }, onFocusOutside),
        onInteractOutside: composeEventHandlers((e) => {
          handleSkipDismissableLayer(e);
        }, onInteractOutside),
        ...props
      }
    );
  }
);
DismissableLayer.displayName = "DismissableLayer";
var dismissable_layer_default = DismissableLayer;

export { dismissable_layer_default as default };
